import { render } from "./App.vue?vue&type=template&id=90794db0"
const script = {}

import "./App.vue?vue&type=style&index=0&id=90794db0&lang=scss"
script.render = render

export default script